import Image from 'next/image';
import React from 'react';

interface LogoProps {
  size?: number;
  showText?: boolean;
}

const LogoInverse: React.FC<LogoProps> = ({ size = 60, showText = true }) => {
  return (
    <div className="flex items-center space-x-4">
      <Image
        src="/images/logo_square.svg"
        alt="Right2Hope Logo"
        width={size}
        height={size}
        className="object-contain"
        priority={false}
      />
      {showText && <span className="mt-1 text-xl text-white font-semibold">Right2Hope</span>}
    </div>
  );
};

export default LogoInverse;
